import { render, staticRenderFns } from "./applySchool.vue?vue&type=template&id=f23a5608"
import script from "./applySchool.vue?vue&type=script&lang=js"
export * from "./applySchool.vue?vue&type=script&lang=js"
import style0 from "./applySchool.vue?vue&type=style&index=0&id=f23a5608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports